import React from 'react';
import PropTypes from 'prop-types';
import { STEPS } from './dataset'
import Space from './space';
import InquiryData from './inquiry-data';

const Proposal = ({ space, type, requestDate, name, email, userType }) => {
  const leadTypeMap = {
    bookavisit: 'Book a Visit',
    inquiry: 'Inquiry'
  }
  return (
    <div className="w-full h-full overflow-y-auto">
      <div className="px-5 pt-5 pb-2">
        <h5 className="text-sm text-gray-700 font-bold uppercase mb-4">LEAD DETAILS</h5>
        <Space
          image={space.image}
          title={space.title} address={space.address}
          spaceUrl={space.spaceUrl} />
        <div className="flex items-start justify-evenly">
          <InquiryData label={'LEAD TYPE'} value={leadTypeMap[type]} />
          <InquiryData label={'REQUEST DATE'} value={requestDate} />
        </div>
        <div className="flex items-start justify-between">
          <InquiryData label={`${userType} NAME`} value={name} />
          <InquiryData label={`${userType} EMAIL`} value={email.replace(
            /^(.{3}).*@(.*)\.(.*)$/,
            (_, prefix, domain, suffix) => `${prefix}*@******.${suffix}`
          )} />
        </div>
        <div className="flex items-start justify-between">
          <InquiryData label={`${userType} MOBILE`} value={'********'} />
        </div>
      </div>
      <div className="steps">
        <div className="px-5">
          <h6 className="text-xs text-primary-darkgray font-bold uppercase mb-4">NEXT STEPS</h6>
        </div>
        {STEPS.map((step, index) => (
          <div className="w-full flex mb-2" key={index}>
            <div className="w-1/6 bg-white-smoke flex items-center justify-center text-primary-lightgray text-3xl">
              {index + 1}
            </div>
            <div className="w-5/6 px-2 py-1 bg-lightgray">
              <p className="uppercase font-semibold text-xs text-primary-black">{step.title}</p>
              <p className="text-xs text-dim-gray">{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

Proposal.propTypes = {
  space: PropTypes.object,
  type: PropTypes.string,
  requestDate: PropTypes.string,
  name: PropTypes.string,
  email: PropTypes.string,
  userType: PropTypes.string,
  phone: PropTypes.string,
};


export default Proposal;
